import React from "react";
import $ from 'jquery';

export default function () {
    $.extend(true, $.fn.dataTable.defaults, {
        "stateSave": true,
        "stateDuration": 60,
        "orderCellsTop": true,
        "processing": true,
        "serverSide": true,
        "bFilter": true,
    });

    return (
        <>
        </>
    );
}